<template>
  <MarketInsightsPage
    v-slot="{ slug, categoriesArticles, playVideo }"
    :market="market"
  >
    <NuxtPage
      :slug="slug"
      :categories-articles="categoriesArticles"
      :categories-videos="categoriesArticles"
      @play-video="playVideo"
    />
  </MarketInsightsPage>
</template>

<script setup lang="ts">
import MarketInsightsPage from '~/components/market/MarketInsightsPage.vue'
import { CATHODE, MARKET } from '~/constants/services/constants'

const market = {
  ...CATHODE,
  hideAnalysis: true,
}

definePageMeta({ layout: 'services' })

const { getSeoInfo } = useSeo()
const seo = getSeoInfo({
  title: `${MARKET.name}: ${CATHODE.name} Market Insights`,
})
useHead(seo)
</script>
